'use strict';

function miniflat(value) {
  return value === null || value === undefined ? [] : 'length' in value ? value : [value];
}
module.exports = miniflat;